// src/components/Documentos.jsx

import React, { useMemo, useState } from "react";
import TemplateGrid from "./documentos/TemplateGrid";
import TemplatePreviewModal from "./documentos/TemplatePreviewModal"; // ← 1. Import

export const DOCUMENT_TYPES = [
  { id: "cotizacion", label: "Cotizaciones" },
  { id: "factura", label: "Facturas" },
  { id: "remision", label: "Remisiones" },
  { id: "orden-compra", label: "Órdenes de Compra" },
];

const SORT_OPTIONS = [
  { id: "recent", label: "Más reciente" },
  { id: "old", label: "Más antiguo" },
  { id: "name-asc", label: "Nombre (A–Z)" },
  { id: "name-desc", label: "Nombre (Z–A)" },
];

const DEFAULT_ACTIVE_IDS = {
  cotizacion: "cotizacion-tech-blue",
  factura: "factura-moderna",
  remision: "remision-estandar",
  "orden-compra": "orden-compra-formal",
};

export default function Documentos() {
  const [activeType, setActiveType] = useState(DOCUMENT_TYPES[0].id);
  const [sortBy, setSortBy] = useState(SORT_OPTIONS[0].id);
  const [activeIds, setActiveIds] = useState(DEFAULT_ACTIVE_IDS);
  const [previewId, setPreviewId] = useState(null); // ← 2. Estado del modal

  const activeTypeLabel = useMemo(
    () => DOCUMENT_TYPES.find((x) => x.id === activeType)?.label || "Documento",
    [activeType],
  );

  const sortByLabel = useMemo(
    () => SORT_OPTIONS.find((x) => x.id === sortBy)?.label || "Ordenar por",
    [sortBy],
  );

  const handleSelect = (templateId) => {
    setActiveIds((prev) => ({ ...prev, [activeType]: templateId }));
    // TODO: persistir en Firestore → useDocumentTemplate()
  };

  const handleEdit = (templateId) => {
    // TODO: abrir modal de personalización
    console.log("Editar plantilla:", templateId);
  };

  return (
    <div className="documentos">
      {/* ── Encabezado + filtros ── */}
      <div className="documentos-header">
        <div className="documentos-title">
          <h4 className="documentos-h4">Plantillas de Documento</h4>
          <p className="documentos-subtitle">
            Configura el diseño visual de tus documentos.
          </p>
        </div>

        <div className="documentos-filters">
          <div className="documentos-filter">
            <span className="documentos-filter-label">Documento:</span>
            <select
              value={activeType}
              onChange={(e) => setActiveType(e.target.value)}
              className="documentos-filter-select"
              aria-label="Seleccionar tipo de documento"
              title={`Documento: ${activeTypeLabel}`}
            >
              {DOCUMENT_TYPES.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.label}
                </option>
              ))}
            </select>
          </div>

          <div className="documentos-filter">
            <span className="documentos-filter-label">Ordenar por:</span>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="documentos-filter-select"
              aria-label="Seleccionar orden"
              title={`Ordenar por: ${sortByLabel}`}
            >
              {SORT_OPTIONS.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="documentos-divider" />

      {/* ── Grid de plantillas ── */}
      <TemplateGrid
        activeType={activeType}
        sortBy={sortBy}
        activeId={activeIds[activeType]}
        onSelect={handleSelect}
        onEdit={handleEdit}
        onPreview={setPreviewId}
      />

      {/* ── Modal de preview ── */}
      <TemplatePreviewModal
        isOpen={!!previewId}
        templateId={previewId}
        activeId={activeIds[activeType]}
        onClose={() => setPreviewId(null)}
        onSelect={handleSelect}
      />
    </div>
  );
}
